<template>
    <div :class="buttonClass" @click="subscribe">
        <div class="iap-featured-product-button-inner" style="font-weight: 600;">
            <slot name="button-text">
                {{ buttonText }}
            </slot>
        </div>
        <mdi v-show="overrideClass === '' && productsLoaded && !loading" :style="{marginLeft: '10px', color: arrowColor}">mdiChevronRight</mdi>
    </div>
</template>

<style>
    .iap-featured-product-button {
        width: 260px;
        background: #ffaa07;
        display: flex!important;
        justify-content: center;
        align-items:center;
        border-radius: 20px;
        box-shadow: 2px 2px 2px rgba(0,0,0,.5);
    }
    .iap-featured-product-button .iap-featured-product-button-inner {
        flex-grow: 0;
        margin: 12px 8px 12px 8px;
        line-height: 1;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: -0.5px;
        color: #fff;
    }
</style>

<script>
export default {
    props: {
        sku: {
            type: String,
            default: ""
        },
        referrer: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "SUBSCRIBE NOW"
        },
        overrideClass: {
            type: String,
            default: ""
        },
        arrowColor: {
            type: String,
            default: "#fff"
        }
    },
    data() {
        return {
            loading: true,
            product: {},
            productsLoaded: window.IAP.status.includes('offeringsLoaded'),
        }
    },
    computed: {
        buttonClass() {
            if (this.overrideClass !== "") return this.overrideClass;
            const classes = ['iap-featured-product-button'];
            if (!this.loading) classes.push('pm-btn-glowing');
            return classes;
        },
        buttonText() {
            if (!this.productsLoaded) return "Loading...";
            if (this.loading) return "Opening " + (this.$isIOS() ? "the App Store" : "Google Play") + "...";
            return this.text;
        },
    },
    created() {
        if (window.IAP.status.includes('offeringsLoaded')) {
            this.init();
        }
        this.$bus.$on("flutter:onOfferingsUpdated", () => {
            this.init();
        });
        this.registerBusEvent('subscribe:process', this.changeProcessStatus);
        this.registerBusEvent('subscribe:cancelled', () => {
            this.changeProcessStatus(false);
        });
    },
    mounted() {
        if (IAP.autoRetryPurchase === true) {
            IAP.autoRetryPurchase = false;
            this.subscribe();
        }
    },
    methods: {
        getDefaultProduct() {
            this.sku = window.IAP.getDefaultSku();
            this.product = window.IAP.getProduct(this.sku);
            if (this.product === null) return;

            if (this.product.currencyCode.toUpperCase() === "INR" || this.product.currencyCode.toUpperCase() === "HUF") {
                this.sku = IAP.getDefaultSku();
                this.product = IAP.getProduct(this.sku);
            }
        },
        init() {
            if (this.sku === "") this.getDefaultProduct();
            else this.product = window.IAP.getProduct(this.sku);
            if (this.product === null) return;
            this.loading = false;
            this.productsLoaded = true;
        },
        changeProcessStatus(data) {
            this.loading = Boolean(data);
        },
        subscribe() {
            if (this.loading || !this.productsLoaded) return;
            this.loading = true;
            window.IAP.subscribe(this.sku);

            if (this.referrer !== "") {
                window.Tracker.logEvent({
                    event_name: "premium_buy_" + this.sku,
                    event_category: "iap",
                    event_label: this.referrer,
                });
            }

            this.$emit('click');
        },
    }
};
</script>
